/**
 * util functions for RMSE calculations
 *
 * 2021-07-29 JPH changed structure of dataset to use indexes instead of keys
 * JPH added RSE Residual Standard Error calculation
 */
export var RMSE = {};
//module.exports = RMSE;
/**
 * compute the error
 */
RMSE.error = function (val) {
    /**
     * return val.actual - val.predicted;
     */
    return val[0] - val[1];
};
/**
 * compute the squared error
 */
RMSE.squaredError = function (vals) {
    var errors = [];
    for (var i = vals.length - 1; i >= 0; i--) {
        errors.push(Math.pow(RMSE.error(vals[i]), 2));
    }
    return errors;
};
/**
 * compute the mean
 */
RMSE.mean = function (vals) {
    var total = 0;
    for (var i = vals.length - 1; i >= 0; i--) {
        total += vals[i];
    }
    return total / vals.length;
};
/**
 * compute the mean square error
 */
RMSE.mse = function (vals) {
    return RMSE.mean(RMSE.squaredError(vals));
};
/**
 * compute the root mean squared error
 * @param  {Array [actual_number, predicted_number], ...} vals
 *         An array of arrays.
 *         ie. [
 *              [0.10, 0.15],
 *              [0.20, 0.21],
 *              ]
 * @return {number}  The root mean square error
 */
RMSE.rmse = function (vals) {
    return Math.sqrt(RMSE.mse(vals));
};
/**
 * compute the Residual Standard Error
 *
 * The degrees of freedom df is equal to the sample size minus the number of parameters we’re trying to estimate.
 * For example, if we’re estimating 2 parameters β0 and β1 as in:
 * Y = β0 + β1X + ε
 * Then, df = n – 2
 * If we’re estimating 3 parameters, as in:
 * Y = β0 + β1X1 + β2X2 + ε
 * Then, df = n – 3
 * And so on…
 */
RMSE.rse = function (vals, nb_params) {
    var numerateur = RMSE.squaredError(vals);
    var df = vals.length - nb_params;
    var sumNum = 0;
    for (var i = numerateur.length - 1; i >= 0; i--) {
        sumNum += numerateur[i];
    }
    return Math.sqrt(sumNum / df);
};
